import { assign } from "xstate";

const memorizeStep = assign({
  //Add the following state to the stack
  stack: (context: any, event, meta) => context.stack.concat([meta.state]),
  //Remember the entered value
  memory: (context: any, event: any, meta) => {
    if (typeof meta.state !== "undefined") {
      context.memory[meta.state?.value.toString()] = event.data;
    }
    return context.memory;
  },
});

export default memorizeStep